// Preloads the generated photoreal game art and exposes a cached registry.
const FILES = {
  nicaflow: "nicaflow.png",
  elvin: "elvin.png",
  mercado: "mercado.png",
  isaacreyes: "isaacreyes.png",
  jahoskachamorro: "jahoskachamorro.png",
  influencer: "influencer.png",
  angelmick: "angelmick.png",
  javydade: "javydade.png",
  carriage: "carriage.png",
  tuktuk: "tuktuk.png",
  moto: "moto.png",
  dongregorio: "dongregorio.png",
  gordankemash: "gordankemash.png",
  chasedawson_nica: "chasedawson_nica.png",
  chasedawson_leones: "chasedawson_leones.png",
  nacatamal: "nacatamal.png",
  quesillo: "quesillo.png",
  jorge: "jorge.png",
  laborracha: "laborracha.png",
  ranchero: "ranchero.png",
  surfista: "surfista.png",
  pandillero: "pandillero.png",
  gueguense: "gueguense.png",
  gigantona: "gigantona.png",
  dog: "dog.png",
  abuela: "abuela.png",
  abuela_carib: "abuela_carib.png",
  boss: "boss.png",
  beer: "beer.png",
  chancleta: "chancleta.png",
  pinata: "pinata.png",
  police: "police.png",
  // single plates (menus)
  bg_managua: "bg_managua.jpg",
  bg_granada: "bg_granada.jpg",
  bg_sanjuan: "bg_sanjuan.jpg",
  bg_cerronegro: "bg_cerronegro.jpg",
  bg_bluefields: "bg_bluefields.jpg",
  maypole: "maypole.png",
  // immersive non-repeating street segments (gameplay)
  bg_managua_0: "bg_managua_0.jpg",
  bg_managua_1: "bg_managua_1.jpg",
  bg_managua_2: "bg_managua_2.jpg",
  bg_managua_trees: "bg_managua_trees.jpg",
  bg_managua_cathedral: "bg_managua_cathedral.jpg",
  bg_managua_cathedral2: "bg_managua_cathedral2.jpg",
  bg_managua_stadium: "bg_managua_stadium.jpg",
  bg_managua_treeplaza1: "bg_managua_treeplaza1.jpg",
  bg_managua_treeplaza2: "bg_managua_treeplaza2.jpg",
  bg_managua_treeplaza1_far: "bg_managua_treeplaza1_far.jpg",
  bg_managua_treeplaza2_far: "bg_managua_treeplaza2_far.jpg",
  bg_managua_treeplaza1_near: "bg_managua_treeplaza1_near.png",
  bg_managua_treeplaza2_near: "bg_managua_treeplaza2_near.png",
  bg_granada_0: "bg_granada_0.jpg",
  bg_granada_1: "bg_granada_1.jpg",
  bg_granada_2: "bg_granada_2.jpg",
  bg_sanjuan_0: "bg_sanjuan_0.jpg",
  bg_sanjuan_1: "bg_sanjuan_1.jpg",
  bg_sanjuan_2: "bg_sanjuan_2.jpg",
  bg_cerronegro_0: "bg_cerronegro_0.jpg",
  bg_cerronegro_1: "bg_cerronegro_1.jpg",
  bg_cerronegro_2: "bg_cerronegro_2.jpg",
  bg_cerronegro_3: "bg_cerronegro_3.jpg",
  bg_bluefields_0: "bg_bluefields_0.jpg",
  bg_bluefields_1: "bg_bluefields_1.jpg",
  bg_bluefields_2: "bg_bluefields_2.jpg",
  bg_bluefields_3: "bg_bluefields_3.jpg",
  bg_cornisland: "bg_cornisland.jpg",
  bg_cornisland_0: "bg_cornisland_0.jpg",
  bg_cornisland_1: "bg_cornisland_1.jpg",
  bg_cornisland_2: "bg_cornisland_2.jpg",
  bg_cornisland_3: "bg_cornisland_3.jpg",
  bg_cornisland_4: "bg_cornisland_4.jpg",
  bg_cornisland_5: "bg_cornisland_5.jpg",
  // featured special level — El Timón, San Juan del Sur
  bg_eltimon_0: "bg_eltimon_0.jpg",
  bg_eltimon_1: "bg_eltimon_1.jpg",
  bg_eltimon_2: "bg_eltimon_2.jpg",
  bg_eltimon_3: "bg_eltimon_3.jpg",
  bg_eltimon_4: "bg_eltimon_4.jpg",
  bg_eltimon_5: "bg_eltimon_5.jpg",
  bg_eltimon_6: "bg_eltimon_6.jpg",
  bg_eltimon_7: "bg_eltimon_7.jpg",
  bg_eltimon_8: "bg_eltimon_8.jpg",
  bg_eltimon_9: "bg_eltimon_9.jpg",
  bg_eltimon_10: "bg_eltimon_10.jpg",
  bg_eltimon_12: "bg_eltimon_12.jpg",
  bg_eltimon_13: "bg_eltimon_13.jpg",
  bg_eltimon_14: "bg_eltimon_14.jpg",
  bg_eltimon_card: "bg_eltimon_card.jpg",
  // featured special level — Pan de Vida, Granada (photo backgrounds + bread collectible)
  bg_pandevida_0: "bg_pandevida_0.webp",
  bg_pandevida_1: "bg_pandevida_1.webp",
  bg_pandevida_2: "bg_pandevida_2.webp",
  bg_pandevida_3: "bg_pandevida_3.webp",
  bg_pandevida_4: "bg_pandevida_4.webp",
  bg_pandevida_5: "bg_pandevida_5.webp",
  bg_pandevida_card3: "bg_pandevida_card3.webp",
  bread: "bread.png",
  pizza: "pizza.png",
  sushi: "sushi.png",
  // volcano boarding (top-down)
  volcano_slope: "volcano_slope.jpg",
  volcano_crater: "volcano_crater.jpg",
  volcano_town: "volcano_town.jpg",
  // rodeo bull riding bonus
  rodeo_bull: "rodeo_bull.png",
  rodeo_ground: "rodeo_ground.jpg",
  rodeo_card: "rodeo_card.jpg",
  bonus_volcano_card: "bonus_volcano_card.jpg",
  bonus_ocean_card: "bonus_ocean_card.jpg",
  bonus_rodeo_card: "bonus_rodeo_card.jpg",
  boss_bull: "boss_bull.png",
  boss_ganadero: "boss_ganadero.png",
  boss_gigantona: "boss_gigantona.png",
  boss_payaso: "boss_payaso.png",
  stampede_bull_a: "stampede_bull_a.png",
  stampede_bull_b: "stampede_bull_b.png",
  sun_cowboy: "sun_cowboy.png",
  // rodeo side-scroll level
  rodeo_arena_bg: "rodeo_arena_bg.jpg",
  rodeo_sky: "rodeo_sky.jpg",
  rodeo_stands: "rodeo_stands.jpg",
  rodeo_stands_b: "rodeo_stands_b.jpg",
  rodeo_stands_c: "rodeo_stands_c.jpg",
  obs_hay: "obs_hay.png",
  obs_goat: "obs_goat.png",
  obs_chicken: "obs_chicken.png",
  obs_fence: "obs_fence.png",
  obs_trough: "obs_trough.png",
  obs_horse: "obs_horse.png",
  obs_moto: "obs_moto.png",
  obs_mariachi: "obs_mariachi.png",
  // seated bull-riding poses (one per playable character)
  jahoskachamorro_ride: "jahoskachamorro_ride.png",
  isaacreyes_ride: "isaacreyes_ride.png",
  javydade_ride: "javydade_ride.png",
  elvin_ride: "elvin_ride.png",
  mercado_ride: "mercado_ride.png",
  nicaflow_ride: "nicaflow_ride.png",
  angelmick_ride: "angelmick_ride.png",
  influencer_ride: "influencer_ride.png",
  chasedawson_nica_ride: "chasedawson_nica_ride.png",
  chasedawson_leones_ride: "chasedawson_leones_ride.png",
  dongregorio_ride: "dongregorio_ride.png",
  gordankemash_ride: "gordankemash_ride.png",
  nacatamal_ride: "nacatamal_ride.png",
  quesillo_ride: "quesillo_ride.png",
  ranchero_ride: "ranchero_ride.png",
  pandillero_ride: "pandillero_ride.png",
  laborracha_ride: "laborracha_ride.png",
  jorge_ride: "jorge_ride.png",
  surfista_ride: "surfista_ride.png",
  gueguense_ride: "gueguense_ride.png",
  gigantona_ride: "gigantona_ride.png",
  enanocabezon: "enanocabezon.png",
  elespanol: "elespanol.png",
  enanocabezon_ride: "enanocabezon_ride.png",
  elespanol_ride: "elespanol_ride.png",
  // underwater treasure dive bonus
  ocean_chest: "ocean_chest.png",
  ocean_trophy: "ocean_trophy.png",
  fish_a: "fish_a.png",
  fish_b: "fish_b.png",
  fish_c: "fish_c.png",
};

const base = `${process.env.PUBLIC_URL || ""}/game-assets`;

const reg = {};
const loaders = {};

// Preloads game art into a cached registry. Pass `keys` to download ONLY those
// assets (per-level / per-round) — this avoids pulling the entire art library
// (~tens of MB) on first load. Already-loaded assets are reused across calls.
export function preloadAssets(keys = null, onProgress = null) {
  const wanted = keys && keys.length ? keys.filter((k) => FILES[k]) : Object.keys(FILES);
  wanted.forEach((key) => {
    if (loaders[key]) return; // already started or done
    loaders[key] = new Promise((resolve) => {
      const img = new Image();
      img.decoding = "async";
      img.onload = () => resolve();
      img.onerror = () => { reg[key] = null; resolve(); };
      img.src = `${base}/${FILES[key].replace(/\.(png|jpe?g)$/i, ".webp")}`;
      reg[key] = img;
    });
  });
  if (onProgress) {
    const total = wanted.length || 1;
    let done = 0;
    onProgress(0, total);
    wanted.forEach((k) => {
      Promise.resolve(loaders[k]).then(() => { done += 1; onProgress(done, total); });
    });
  }
  return Promise.all(wanted.map((k) => loaders[k])).then(() => reg);
}

export function ready(img) {
  return img && img.complete && img.naturalWidth > 0;
}
